module.exports = __webpack_public_path__ + "img/s_live_cover.77cb443a.png";